import React from 'react';

const AboutUs = () => {
  return (
    <div 
      id="about" 
      className="py-16 bg-[#DB7944] text-white"
    >
      <div className="container mx-auto flex flex-col md:flex-row items-center">
        <div className="md:w-1/2 px-4 mb-8 md:mb-0">
          <h2 className="text-4xl font-bold mb-6">About Veltrah</h2>
          <p className="text-lg mb-4">
            We are an AR systems company, we will accelerate the advent of True AR systems. 
            We believe in the fundamental power of humans, and our technologies will enhance the ability 
            of our species to adapt to the new challenges that face us.

          </p>
          <p className="text-lg">
            With a focus on cutting-edge technologies, we turn complex 
            challenges into opportunities for growth and innovation.
          </p>
        </div>
        <div className="md:w-1/2 px-4">
          <div className="bg-white rounded-lg overflow-hidden shadow-lg">
            <div className="bg-[#365DC9] h-2"></div>
            <div className="p-6">
              <h3 className="text-2xl font-semibold mb-4 text-[#36A6C9]">Our Mission</h3>
              <p className="text-gray-700">
                We will enable humans the use of their fifth appendage, their eyes, to interact with the digital world. 
                Our company has inclusivity as a core value, we are committed to 
                serving all of humanity with our products.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;